/* SHARPON — interactions du thème
   Menu mobile, tiroir panier AJAX, popup lead magnet, formulaires Klaviyo. */

(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Menu déroulant (logo + chevron) ---------- */

  var dropToggle = document.querySelector('[data-drop-toggle]');
  var dropPanel = document.querySelector('[data-drop-panel]');
  function closeDrop() {
    if (!dropPanel) return;
    dropPanel.classList.remove('is-open');
    if (dropToggle) {
      dropToggle.classList.remove('is-open');
      dropToggle.setAttribute('aria-expanded', 'false');
    }
  }
  if (dropToggle && dropPanel) {
    dropToggle.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = dropPanel.classList.toggle('is-open');
      dropToggle.classList.toggle('is-open', open);
      dropToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-drop-panel]') && !e.target.closest('[data-drop-toggle]')) closeDrop();
    });
  }

  /* ---------- Tiroir panier ---------- */

  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function refreshCart() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html || !drawer) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        var count = tmp.querySelector('[data-cart-count-source]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          var n = count ? count.textContent.trim() : '0';
          el.textContent = n;
          el.hidden = n === '0';
        });
      });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      /* Ouvre le tiroir même si le rafraîchissement échoue (aperçu statique, réseau) */
      refreshCart().catch(function () {}).then(openDrawer);
    }
    if (e.target.closest('[data-cart-close]') || e.target.matches('.cart-drawer__overlay')) {
      closeDrawer();
    }
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      var line = qtyBtn.getAttribute('data-line');
      var qty = parseInt(qtyBtn.getAttribute('data-qty'), 10);
      fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
      }).then(refreshCart);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer();
      closePopup();
      closeDrop();
    }
  });

  /* ---------- Gérer mes cookies : rouvre le bandeau de consentement Shopify ---------- */

  document.addEventListener('click', function (e) {
    var lien = e.target.closest('[data-cookie-prefs]');
    if (!lien) return;
    e.preventDefault();
    if (window.privacyBanner && window.privacyBanner.showPreferences) {
      window.privacyBanner.showPreferences();
    } else if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.openBanner) {
      window.Shopify.customerPrivacy.openBanner();
    } else {
      alert('Le bandeau de cookies n’est pas encore activé (Paramètres → Confidentialité des clients dans Shopify).');
    }
  });

  /* ---------- Ajout au panier (formulaires produit) ---------- */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('disabled', ''); }
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Erreur'); });
        return r.json();
      })
      .then(function () { return refreshCart(); })
      .then(openDrawer)
      .catch(function (err) {
        var msg = form.querySelector('[data-form-error]');
        if (msg) { msg.textContent = err.message; msg.hidden = false; }
      })
      .finally(function () { if (btn) btn.removeAttribute('disabled'); });
  });

  /* ---------- Sélecteur de variantes : mise à jour du prix ---------- */

  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    var priceEl = form.querySelector('[data-price]');
    form.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (priceEl && input.dataset.price) priceEl.textContent = input.dataset.price;
      });
    });
  });

  /* ---------- Date de première livraison (abonnement) ---------- */

  document.querySelectorAll('[data-delivery-date]').forEach(function (el) {
    var lead = parseInt(el.dataset.lead || '2', 10);
    var d = new Date();
    d.setDate(d.getDate() + lead);
    try {
      el.textContent = d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    } catch (e) {
      el.textContent = d.toLocaleDateString('fr-FR');
    }
  });

  /* ---------- Popup « Comment fonctionne l'abonnement » ---------- */

  function closeAboModals() {
    document.querySelectorAll('[data-modal]:not([hidden])').forEach(function (m) { m.hidden = true; });
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) {
      var name = opener.getAttribute('data-modal-open');
      var scope = opener.closest('.abo') || document;
      var modal = scope.querySelector('[data-modal="' + name + '"]');
      if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-modal-close]')) { closeAboModals(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAboModals(); }
  });

  /* ---------- Popup lead magnet ---------- */

  var popup = document.getElementById('LeadPopup');
  var POPUP_KEY = 'sharpon-popup-seen';

  function closePopup() {
    if (!popup) return;
    popup.classList.remove('is-open');
    try { localStorage.setItem(POPUP_KEY, '1'); } catch (e) { /* navigation privée */ }
  }

  if (popup) {
    var delay = parseInt(popup.dataset.delay || '12', 10) * 1000;
    var seen = null;
    try { seen = localStorage.getItem(POPUP_KEY); } catch (e) { seen = '1'; }
    if (!seen) {
      setTimeout(function () { popup.classList.add('is-open'); }, delay);
    }
    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-popup-close]') || e.target.matches('.lead-popup__overlay')) closePopup();
    });
  }

  /* ---------- Animations au scroll ---------- */

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var revealSelectors = [
      '.conviction', '.step', '.stat', '.callout', '.actif',
      '.article-card', '.diptych__media', '.diptych__body',
      '.labo__stat', '.gelule__media', '.manifesto h2', '.manifesto__punch',
      '.formule__media', '.product-panel__gallery', '.etude'
    ].join(', ');
    document.querySelectorAll(revealSelectors).forEach(function (el) {
      el.classList.add('reveal');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });
    document.querySelectorAll('.reveal, .souligne').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.souligne').forEach(function (el) { el.classList.add('in-view'); });
  }

  /* ---------- Gélule scrollytelling (section épinglée) ---------- */

  var pinEls = document.querySelectorAll('[data-gelule-pin]');
  if (pinEls.length && !reduceMotion) {
    var pinTicking = false;
    function updatePins() {
      pinTicking = false;
      var vh = window.innerHeight;
      pinEls.forEach(function (pin) {
        var rect = pin.getBoundingClientRect();
        var total = pin.offsetHeight - vh;
        var p = total > 80
          ? -rect.top / total
          : (vh * 0.9 - rect.top) / (vh * 0.6);
        p = Math.max(0, Math.min(1, p));
        /* Phase 1 (0 → 0.4) : la gélule s'ouvre */
        var open = Math.min(1, p / 0.4);
        pin.style.setProperty('--open', open.toFixed(3));
        /* Phase 2 (0.42 → 0.87) : les annotations apparaissent une à une */
        pin.querySelectorAll('[data-step]').forEach(function (c) {
          var seuil = 0.42 + (parseInt(c.getAttribute('data-step'), 10) - 1) * 0.15;
          c.classList.toggle('is-on', p >= seuil);
        });
      });
    }
    window.addEventListener('scroll', function () {
      if (!pinTicking) { pinTicking = true; requestAnimationFrame(updatePins); }
    }, { passive: true });
    window.addEventListener('resize', updatePins);
    updatePins();
  } else {
    pinEls.forEach(function (pin) {
      pin.style.setProperty('--open', '1');
      pin.querySelectorAll('[data-step]').forEach(function (c) { c.classList.add('is-on'); });
    });
  }

  /* ---------- Carrousels ---------- */

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    var slides = carousel.querySelectorAll('.carousel__slide');
    if (!track || slides.length < 2) {
      var nav = carousel.querySelector('.carousel__nav');
      var dots = carousel.querySelector('.carousel__dots');
      if (nav) nav.remove();
      if (dots) dots.remove();
      return;
    }
    var dotsWrap = carousel.querySelector('.carousel__dots');
    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'carousel__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        dot.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      });
    }
    function go(dir) {
      var w = track.clientWidth;
      var next = Math.round(track.scrollLeft / w) + dir;
      /* Boucle : après la dernière image on revient à la première, et inversement */
      if (next >= slides.length) next = 0;
      if (next < 0) next = slides.length - 1;
      track.scrollTo({ left: next * w, behavior: 'smooth' });
    }
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }, { passive: true });
  });

  /* ---------- Formulaires Klaviyo (newsletter + popup) ---------- */

  document.querySelectorAll('form[data-klaviyo-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var companyId = form.dataset.companyId;
      var listId = form.dataset.listId;
      var email = form.querySelector('input[type="email"]').value;
      var success = form.parentElement.querySelector('[data-klaviyo-success]');

      if (!companyId || !listId) {
        /* Klaviyo non configuré : on affiche quand même la confirmation
           pour ne pas perdre le visiteur, mais l'email n'est pas collecté. */
        form.hidden = true;
        if (success) success.hidden = false;
        return;
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }).finally(function () {
        form.hidden = true;
        if (success) success.hidden = false;
        try { localStorage.setItem(POPUP_KEY, '1'); } catch (err) { /* ignore */ }
      });
    });
  });
})();
